import { client } from '../common/client';
import type { FiboSearchRequest, FiboSearchResponse } from './utils/types';

class FiboAPIClient {
  public async getFiboSearch(params?: FiboSearchRequest): Promise<FiboSearchResponse> {
    return await client.get(`/fibosearch`, { params }).then((res) => res.json());
  }
}

export const fiboAPIClient = new FiboAPIClient();
